import { createStore } from 'vuex';
import { getParamType } from '@/libs/global';
import page from './Modules/page';
import dialog from './Modules/dialog';
import WebStorage from '@/libs/Storage/webStorage';

export default createStore({
  state: {
  },
  mutations: {
    CLEAR_PARAM (state, { moduleName, updateState }) {
      updateState.forEach((item, index) => {
        const itemType = getParamType(item);

        if (itemType === 'String') {
          state[moduleName][item] = '';
          WebStorage.setLocal(item, '');
        } else if (itemType === 'Object') {
          const itemName = Object.keys(item)[0];
          state[moduleName][itemName] = item[itemName];
          WebStorage.setLocal(itemName, item[itemName]);
        }
      });
    },
    SET_OBJ_DATA (state, { module, itemName, key, value }) {
      if (getParamType(state[module][itemName]) === 'Object') {
        state[module][itemName][key] = value;
        WebStorage.setLocal('headerData', state[module].headerData);
      }
    }
  },
  actions: {
  },
  modules: {
    page,
    dialog
  }
});
